module.exports = __webpack_public_path__ + "static/media/checklist.d03127f3.png";